export default __webpack_public_path__ + "static/ai_logo-80376b1c3d950f0f632d2e450517bc8e.png";